/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type HomeUnitsQueryVariables = {};
export type HomeUnitsQueryResponse = {
    readonly units: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
        readonly placedAt: string;
    }>;
};
export type HomeUnitsQuery = {
    readonly response: HomeUnitsQueryResponse;
    readonly variables: HomeUnitsQueryVariables;
};



/*
query HomeUnitsQuery {
  units {
    id
    name
    placedAt
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Unit",
    "kind": "LinkedField",
    "name": "units",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "placedAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "HomeUnitsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "HomeUnitsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "8c5822e939d53c482021a56c0f379875",
    "id": null,
    "metadata": {},
    "name": "HomeUnitsQuery",
    "operationKind": "query",
    "text": "query HomeUnitsQuery {\n  units {\n    id\n    name\n    placedAt\n  }\n}\n"
  }
};
})();
(node as any).hash = '9103d10783f770ae14a58779c4e06c5c';
export default node;
